/* UtilEventKeyPolyfill util */
export default class UtilEventKeyPolyfill {
    /**
     * Return the key code of an keyboard event by considering special key codes of IE/Edge browsers.
     *
     * @param {KeyboardEvent} e
     * @return string The normalized key code
     */
    getKeyCode(e) {
        // Fallback values for IE/Edge
        // @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        const ieMapping = {
            Down: 'ArrowDown',
            Up: 'ArrowUp',
            Left: 'ArrowLeft',
            Right: 'ArrowRight',
            Esc: 'Escape',
        };
        return ieMapping[e.key] || e.key;
    }
}
